<template>
  <div>
    <footer class="footer">
      <b-container class="d-flex justify-content-between">
        <span
          class="text-muted d-block text-center text-sm-start d-sm-inline-block"
        >
          © {{ year }}
          <a href="https://www.innovate10x.com/" target="_blank">
            Innovate 10x</a
          >
          "Powering What's Next"
        </span>
        <span class="float-none float-sm-end mt-1 mt-sm-0 text-end">
          <b>{{ $translate("versions") }}</b>
          {{ ` web: ${web_version}  api: ${api_version}` }}</span
        >
      </b-container>
    </footer>
  </div>
</template>
<script>
import "@/assets/css/style.css";
import "@/assets/vendors/mdi/css/materialdesignicons.min.css";

export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    web_version() {
      return this.$store.state.web_version;
    },
    api_version() {
      return this.$store.state.api_version;
    },
  },
};
</script>
<style></style>
